module.exports = __webpack_public_path__ + "static/media/Galano_Grotesque_Extra_Bold.ff1f5e01.otf";